module.exports = __webpack_public_path__ + "static/media/card-soul.f148547d.png";